import { DataBean } from "../DataBean";

export class CashFlow extends DataBean {



    public async getCashFlow(year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashFlow_Number", [year]);
    }
 public async updateCashFlowDataFor(year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateCashFlowDataFor_Number_Number", [year,month]);
    }
    
}